import axios from "axios";

import { useState, useEffect } from "react";
import { BACKEND } from "../config/configEnvs";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import DetailsButton from "../components/ui/components/DetailsButton";
import { formatDate } from "../utils/rawData/dateValues";
import Tooltip from "../components/ui/ToolTip";
import EmptyButton from "../components/ui/components/EmptyButton";
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import { FaCalendarDays } from "react-icons/fa6";
import { useSelector } from "react-redux";
import CheckBox from "../components/ui/components/CheckBox";
import Selector from "../components/ui/components/Selector";
import { Limits50_100 } from "../utils/plainValues/DefaultLimits";
import SearchBar from "../components/ui/components/SearchBar";

const RenovacionHostingyDominios = () => {

  const user = useSelector((state) => state.auth?.user); // Usuario logeado
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() !== "ASISTENTE"

  const [filterDebts, setFilterDebts] = useState(false);
  const [filterNonPayed, setFilterNonPayed] = useState(false);

  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState([]);

  const recordFilteredMissing = record?.filter(c => c?.services?.some(s => s?.payment?.faltaCompromisoPago === true))
  const recordFilteredPaid = record?.filter(c => c?.services?.some(s => s?.payment?.faltaCompromisoPago !== true))

  const recordToUse = filterDebts ? recordFilteredMissing : recordFilteredPaid
  const filteredNonPayedClients = filterNonPayed ? recordToUse?.filter((c) => c?.services?.some(s => s?.agencyBoughtDomainButUnpaid)) : recordToUse

  const recordSorted = filteredNonPayedClients.sort((a, b) => {
    const aHosting = a.services.find((s) => ["66c474b95d02f2a631e470a2", "66c475035d02f2a631e470ad", "66c474755d02f2a631e47097"].includes(s.servicio?.id));
    const aDomain = a.services.find((s) => s.servicio?.id === "66c465aa5d02f2a631e4708c");
    const bHosting = b.services.find((s) => ["66c474b95d02f2a631e470a2", "66c475035d02f2a631e470ad", "66c474755d02f2a631e47097"].includes(s.servicio?.id));
    const bDomain = b.services.find((s) => s.servicio?.id === "66c465aa5d02f2a631e4708c");

    const aRenewalDate = aHosting?.payment?.fechaLimite || aDomain?.payment?.fechaLimite;
    const bRenewalDate = bHosting?.payment?.fechaLimite || bDomain?.payment?.fechaLimite;

    if (!aRenewalDate && !bRenewalDate) return 0;
    if (!aRenewalDate) return 1;
    if (!bRenewalDate) return -1;

    return new Date(aRenewalDate) - new Date(bRenewalDate);
  });

  const [brandName, setBrandName] = useState("");
  const [agencyActive, setAgencyActive] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(200);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [paises, setPaises] = useState([]);
  const [currencyExchanges, setCurrencyExchanges] = useState({})

  const [hostingAndDomain, setHostingAndDomain] = useState(true);

  const getRecord = async () => { // Obtener los clientes
    try {
      setLoading(true)

      const body = {}

      let url = `${BACKEND}/api/userProcessesInterface/getHostingAndDomainRenewal?category=Hosting y dominio&page=${page}&limit=${limit}`

      if (brandName) {
        url += `&brandName=${brandName}`
      }

      // if (statusFilters) {
      //   body.statusFilters = statusFilters
      // }

      // if (serviceFilters) {
      //   body.serviceFilters = serviceFilters
      // }

      if (agencyActive) {
        url += `&activoAgencia=${agencyActive}`
      }

      if (hostingAndDomain) {
        url += `&hostingAndDomain=${hostingAndDomain}`
      }

      // if (startDate) {
      //   url += `&startDate=${new Date(startDate).toISOString()}`
      // }

      // if (endDate) {
      //   url += `&endDate=${new Date(endDate).toISOString()}`
      // }

      const response = await axios.post(url, body)

      setRecord(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`);
      setPaises(response.data.docs);
    } catch (error) {
      console.error(error);
    }
  }

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }

  const handleSearch = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getRecord()
  }
  
  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };
  
  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (brandName === "") {
      getRecord(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [brandName]);

  useEffect(() => {
    getRecord()
    getPaises()
    getCurrencyExchange()
  }, []);

  useEffect(() => {
    getRecord()
  }, [page, limit, agencyActive]);

  const cols = [
    {id: 1, name: "Cotización", color: "#fcc19a"},
    {id: 2, name: "Empresa", color: "#fcc19a", sticky: true},
    {id: 3, name: "Encargado", color: "#fcc19a"},
    {id: 4, name: "Teléfono", color: "#fcc19a"},
    {id: 5, name: "Web", color: "#fcc19a"},
    {id: 6, name: "Dom", color: "#fcc19a"},
    {id: 7, name: "Agencia compró dominio", color: "#fcc19a"},

    {id: 8, name: "Días para renovar dominio", color: "#d8e9fe"},
    {id: 9, name: "Precio renovación dominio", color: "#d8e9fe"},
    {id: 10, name: "Días para renovar hosting", color: "#d8e9fe"},
    {id: 11, name: "Precio renovación hosting", color: "#d8e9fe"},
    {id: 12, name: "Costo total sin IGV", color: "#d8e9fe"},
    
    {id: 13, name: "Propiedad del dominio", color: "#f2e5a4"},
    {id: 14, name: "Fecha creación", color: "#f2e5a4"},
    {id: 15, name: "Fecha renovación", color: "#f2e5a4"},
    {id: 16, name: "Precio renovación dominio", color: "#f2e5a4"},
    {id: 17, name: "Situación renovación dominio", color: "#f2e5a4"},
    {id: 18, name: "Días para renovar dominio", color: "#f2e5a4"},
    {id: 19, name: "Comentario vendedor", color: "#f2e5a4"},

    {id: 20, name: "Situación renovación hosting", color: "#e2f0ca"},
    {id: 21, name: "Web hosting alojamiento", color: "#e2f0ca"},
    {id: 22, name: "Link copia seguridad", color: "#e2f0ca"},
    {id: 23, name: "Fecha creación", color: "#e2f0ca"},
    {id: 24, name: "Fecha renovación", color: "#e2f0ca"},
    {id: 25, name: "Precio renovación hosting", color: "#e2f0ca"},
    {id: 26, name: "Días para renovar hosting", color: "#e2f0ca"},
    {id: 27, name: "Comentario vendedor", color: "#e2f0ca"},
    {id: 28, name: "Estado desinstalación", color: "#e2f0ca"},
  ]

  const getHeaderColor = (id) => {
    if (id > 0 && id < 8) return "bg-[#fcc19a]";
    if (id > 7 && id < 14) return "bg-[#d8e9fe]";
    if (id > 13 && id < 21) return "bg-[#f2e5a4]";
    if (id > 20 && id < 29) return "bg-[#e2f0ca]";
    return "bg-white";
  }

  const colorMap = {
    "MC Activo": "bg-orange-100 text-yellow-500 font-bold",
    "Cliente": "bg-gray-100 text-gray-500",
    "No renovo": "bg-red-100 text-red-700 font-bold",
  }

  const formatPrice = (price) => {
    if (!price) return "No aplica"
    return price?.toLocaleString("es-PE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "PEN",
      currencyDisplay: "symbol"
    })
  }

  const getCatalogLineTotal = (svc) => {
    if (!svc) return 0
    const rawQty = svc.numeroItems
    const qty = rawQty != null && rawQty !== "" ? Number(rawQty) : 1
    const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1

    if (svc.customPriceActive) {
      return (Number(svc.customPrice) || 0) * safeQty
    }

    const unitPrice = svc.servicio?.preciosUnitarios?.find(
      (p) => p.plan?.id === svc.planServicio?.id
    )?.precio
    return (Number(unitPrice) || 0) * safeQty
  }

  const getLastPaymentServiceAmount = (svc) => {
    if (!svc) return 0
    const montosServicios = svc.payment?.montosServicios
    if (montosServicios?.length) {
      const svcId = typeof svc._id === "object" ? svc._id : (svc._id || svc.id)
      const match = montosServicios.find((m) => {
        const mId = typeof m.servicioId === "object" ? m.servicioId?.id : m.servicioId
        return mId === svcId
      })
      if (match) return Number(match.monto) || 0
    }
    return getCatalogLineTotal(svc)
  }

  const hostingNameMap = {
    "Ruby Hosting (H)": "Hostinger",
    "Gold Hosting (B)": "Banahosting",
    "Diamond Hosting (S)": "Siteground",
  }

  const hostingColorMap = {
    "Hostinger": "text-purple-500 font-bold",
    "Banahosting": "text-orange-500 font-bold",
    "Siteground": "text-green-400 font-bold",
  }

  const getHostingName = (serviceName) => {
    if (!serviceName) return "No aplica";
    
    // Normalizar el nombre del servicio (eliminar espacios extra, convertir a minúsculas)
    const normalizedName = serviceName.trim().toLowerCase();
    
    // Buscar en el mapeo
    const hostingName = Object.entries(hostingNameMap).find(([key]) => 
        key.toLowerCase() === normalizedName
    )?.[1];
    
    return hostingName || "No aplica";
  }
  
  const getDomainRegistered = (plan) => {
    if (!plan) return "No aplica"
    switch (plan.name) {
      case "Premium":
        return "AQP Host"
      case "Pro":
        return "Namecheap"
      default:
        return "No aplica"
    }
  }
  
  const domainRegisteredColorMap = {
    "AQP Host": "text-blue-500",
    "Namecheap": "text-orange-300",
    "No aplica": "text-gray-200",
  }

  const renewalDateMap = (renewalDate) => {
    if (!renewalDate) return "text-gray-200";
    if (renewalDate < 0) return "text-red-500 font-bold";
    if (renewalDate > 0) return "text-green-500 font-bold";
    return "text-gray-200";
  }

  const estadoDesinstalacionOptions = [
    { value: "pendiente_desinstalar", label: "Pendiente", bg: "bg-yellow-100", text: "text-yellow-700", border: "border-yellow-300", title: "Pendiente para desinstalar" },
    { value: "programado_desinstalar", label: "Programado", bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-300", title: "Programado para desinstalar" },
    { value: "desinstalado_completo", label: "Desinstalado", bg: "bg-green-100", text: "text-green-700", border: "border-green-300", title: "Desinstalado + copia + drive + demo" },
  ]

  const getEstadoDesinstalacionStyle = (value) => {
    const style = estadoDesinstalacionOptions.find((o) => o.value === value) || estadoDesinstalacionOptions[0]
    return {
      bg: style.bg,
      text: style.text,
      border: style.border,
      title: style.title,
    }
  }

  const updateEstadoDesinstalacion = async (pagoId, nuevoEstado) => {
    try {
      await axios.put(`${BACKEND}/api/pagosCotizaciones/${pagoId}`, {
        estadoDesinstalacion: nuevoEstado,
      })
      getRecord()
    } catch (error) {
      console.error(error)
    }
  }

  // Drawer

  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(null);

  const handleOpenDrawer = (data) => {
    setDataDrawer(data)
    setOpenDrawer(true)
  } 

  
  const getDomainExtension = (url) => {
    if (!url) return null;
    try {
      const domain = new URL(url).hostname;
      const parts = domain.split('.');
      if (parts.length >= 3 && parts[parts.length - 1].length === 2) {
        // Ejemplo: www.ejemplo.com.pe → .com.pe
        return `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
      }
      // Ejemplo: www.ejemplo.pe → .pe
      return `.${parts[parts.length - 1]}`;
    } catch (e) {
      return null;
    }
  };

  const totalDomainPrice = recordSorted.reduce((acc, curr) => {
    const domain = curr.services.find((s) => s.servicio?.id === "66c465aa5d02f2a631e4708c");
    return acc + getLastPaymentServiceAmount(domain);
  }, 0);

  const totalHostingPrice = recordSorted.reduce((acc, curr) => {
    const hosting = curr.services.find((s) =>
      ["66c474b95d02f2a631e470a2", "66c475035d02f2a631e470ad", "66c474755d02f2a631e47097"].includes(s.servicio?.id)
    );
    return acc + getLastPaymentServiceAmount(hosting);
  }, 0);

  const totalGeneralPrice = totalDomainPrice + totalHostingPrice;

  const getColTotal = (colId) => {
    switch (colId) {
      case 9: case 16: return totalDomainPrice;
      case 11: case 25: return totalHostingPrice;
      case 12: return totalGeneralPrice;
      default: return null;
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">

      <DrawerCotizacionCalendarioPagosDetails
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        dataDrawer={dataDrawer}
        refetch={getRecord}
        isAdmin={isAdmin}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaCalendarDays className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Renovación hosting y dominios</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <CheckBox
              text={`Dominio cubierto por MC (deuda cliente)`}
              checked={filterNonPayed}
              onChange={(e) => setFilterNonPayed(e.target.checked)}
            />

            <CheckBox
              text="Faltó compromiso de pago"
              checked={filterDebts}
              onChange={(e) => setFilterDebts(e.target.checked)}
            />

            <CheckBox
              text="Activos agencia"
              checked={agencyActive}
              onChange={(e) => setAgencyActive(e.target.checked)}
            />
        
            <Selector
              title="Límite"
              value={limit}
              setter={setLimit}
              options={Limits50_100}
              width="w-[5rem]"
            />

            <SearchBar
              value={brandName}
              setter={setBrandName}
              pageSetter={setPage}
              getter={handleSearch}
              placeholder="Buscar marca..."
              text="Buscar"
            />

          </div>

        </div>
      </div>
      
      {/* Total */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between items-center w-full gap-10 p-1">
        <div className="flex flex-row gap-9 items-center justify-center px-4 w-full">
          <div className="flex flex-row gap-4 items-center justify-center px-6">
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span>Total Dominios:</span>
              <span className={`${filterDebts ? "text-red-500" : "text-blue-500"} font-bold`}>
                S/. {totalDomainPrice.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span>Total Hosting:</span>
              <span className={`${filterDebts ? "text-red-500" : "text-blue-500"} font-bold`}>
                S/. {totalHostingPrice.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span>Total General:</span>
              <span className={`${filterDebts ? "text-red-500" : "text-blue-500"} font-bold`}>
                S/. {totalGeneralPrice.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
          <LoadingScreen />
          ) : (
            record.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full text-xs">
                <thead className="sticky top-0 bg-gray-200 z-50">
                  <tr className="text-gray-700 text-center text-xs font-bold z-50">
                    <th colSpan={7} className="px-2 py-3 text-center bg-white border-x border-gray-300 text-black z-50">
                      {/* Vacío */}
                    </th>
                    <th colSpan={6} className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Fecha y precio de renovación HOST y DOMINIO
                    </th>
                    <th colSpan={7} className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Renovación de DOMINIO
                    </th>
                    <th colSpan={9} className="px-2 py-3 text-center bg-[#FE6400] border-x border-gray-300 text-white z-50">
                      Renovación de HOSTING
                    </th>
                  </tr>
                  <tr className="text-gray-700 text-center text-xs z-50">
                    {cols.map((col) => (
                      <th
                        key={col.id}
                        id={col.id}
                        className={`${col.sticky ? "sticky left-0" : ""} px-2 py-3 font-bold text-center border-r border-gray-300 ${getHeaderColor(col.id)} text-black bg-[#FE6400] z-50`}
                      >
                        {col.name}
                      </th>
                    ))}
                  </tr>
                  <tr className="text-center text-xs font-bold z-50 bg-gray-50">
                    {cols.map((col) => {
                      const total = getColTotal(col.id);
                      return (
                        <th
                          key={`total-${col.id}`}
                          className={`px-2 py-2 text-center border border-gray-300 ${col.sticky ? "sticky left-0 bg-gray-50" : ""} ${
                            col.id === 12 ? "bg-gray-200 text-black" : total != null ? "text-blue-600" : "text-gray-300"
                          }`}
                        >
                          {total != null ? formatPrice(total) : ""}
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <tbody>
                  {recordSorted.map((c) => {
                    const hosting = c.services.find((s) =>
                      ["66c474b95d02f2a631e470a2", "66c475035d02f2a631e470ad", "66c474755d02f2a631e47097"].includes(s.servicio?.id)
                    );
                    const domain = c.services.find((s) => s.servicio?.id === "66c465aa5d02f2a631e4708c");
                    
                    // const renewalDomainCheck = domain?.payment?.compraHd
                    const renewalDomainCheck = domain?.boughtHd
                    const renewalHostingCheck = hosting?.payment?.compraHd
                    
                    const entryDateDomain = domain?.fechaIngreso || domain?.fechaInicio || domain?.createdAt;
                    const domainRenewalDate = domain?.payment?.fechaLimite || null;

                    const entryDateHosting = hosting?.fechaIngreso || hosting?.fechaInicio || hosting?.createdAt;
                    const hostingRenewalDate = hosting?.payment?.fechaLimite || null;

                    const daysToRenewDomain = domainRenewalDate ? Math.ceil((new Date(domainRenewalDate) - new Date()) / (1000 * 60 * 60 * 24)) : 0;
                    const daysToRenewHosting = hostingRenewalDate ? Math.ceil((new Date(hostingRenewalDate) - new Date()) / (1000 * 60 * 60 * 24)) : 0;
                    const lineTotalDomain = getLastPaymentServiceAmount(domain);
                    const lineTotalHosting = getLastPaymentServiceAmount(hosting);

                    const domainPagado = domain?.payment?.pagado || false;
                    const hostingPagado = hosting?.payment?.pagado || false;

                    const domainRegistered = getDomainRegistered(domain?.planServicio);
                    const commentDomain = domain?.comentarioVendedor || null;
                    const commentHosting = hosting?.comentarioVendedor || null;
                    const hostingName = getHostingName(hosting?.servicio?.name);

                    const webLink = c?.services[0]?.links?.find((l) => l.titulo === "Link web oficial") || null;
                    const backupLink = c?.services[0]?.links?.find((l) => l.titulo === "Link backup") || null;

                    const domainExtension = webLink ? getDomainExtension(webLink.url) : null;

                    const renewalDomain = !domainRenewalDate ? "Cliente" : daysToRenewDomain < 0 ? "No renovo" : "MC Activo";
                    const renewalHosting = !hostingRenewalDate ? "Cliente" : daysToRenewHosting < 0 ? "No renovo" : "MC Activo";

                    return (
                      <tr key={c.id} className="text-xs py-1 w-full hover:bg-gray-100 transition-all duration-100 z-10">
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300 z-10">
                          <div className="flex items-center justify-center">
                            <DetailsButton content="Ver cotización" action={() => handleOpenDrawer(c?.services[0]?.cotizacion)} />
                          </div>
                        </td>
                        <td className="px-4 py-2 min-w-[200px] max-w-[300px] whitespace-nowrap truncate border border-gray-300 sticky left-0 z-10 bg-white">
                          {c.nombreComercial}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap border border-gray-300">
                          {c.encargadoProyecto || c.nombreGerente}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          {c.telefono || c.telefonoGerente}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          {webLink ? (
                            <DetailsButton content={webLink.url} type="externalLink" action={() => window.open(webLink.url, "_blank")} />
                          ) : (
                            <EmptyButton content="No hay link web oficial" />
                          )}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${domainExtension ? "text-black" : "text-gray-200"}`}>
                          {domainExtension || "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${renewalDomainCheck ? "text-black" : "text-gray-200"}`}>
                          {renewalDomainCheck ? "✅" : "❌"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${renewalDateMap(daysToRenewDomain)}`}>
                          {daysToRenewDomain || "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${lineTotalDomain ? (domainPagado ? "bg-green-50 text-green-700 font-bold" : "text-black") : "text-gray-200"}`}>
                          {formatPrice(lineTotalDomain)} {lineTotalDomain ? (domainPagado ? "✅" : "⏳") : ""}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${renewalDateMap(daysToRenewHosting)}`}>
                          {daysToRenewHosting || "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${lineTotalHosting ? (hostingPagado ? "bg-green-50 text-green-700 font-bold" : "text-black") : "text-gray-200"}`}>
                          {formatPrice(lineTotalHosting)} {lineTotalHosting ? (hostingPagado ? "✅" : "⏳") : ""}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${lineTotalHosting || lineTotalDomain ? ((domainPagado && hostingPagado) ? "bg-green-100 text-green-700 font-bold" : "bg-gray-100 text-black font-bold") : "bg-gray-100 text-gray-200"}`}>
                          {formatPrice(lineTotalHosting + lineTotalDomain)}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${domainRegisteredColorMap[domainRegistered]}`}>
                          {domainRegistered}
                        </td>
                        {/* <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          {domain?.nameServer}
                        </td> */}
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${entryDateDomain ? "text-black" : "text-gray-200"}`}>
                          {entryDateDomain ? formatDate(entryDateDomain.split("T")[0]) : "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${domainRenewalDate ? "text-black" : "text-gray-200"}`}>
                          {domainRenewalDate ? formatDate(domainRenewalDate.split("T")[0]) : "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${lineTotalDomain ? (domainPagado ? "bg-green-50 text-green-700 font-bold" : "text-black") : "text-gray-200"}`}>
                          {formatPrice(lineTotalDomain)} {lineTotalDomain ? (domainPagado ? "✅" : "⏳") : ""}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${colorMap[renewalDomain]}`}>
                          {renewalDomain}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${renewalDateMap(daysToRenewDomain)}`}>
                          {daysToRenewDomain || "No aplica"}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <div className="flex items-center justify-center">
                            {commentDomain ? (
                              <Tooltip content={commentDomain}>
                                <div className="flex items-center justify-center">
                                  <FaEye className="text-black hover:cursor-pointer" />
                                </div>
                              </Tooltip>
                            ) : (
                              <FaEyeSlash className="text-gray-200" />
                            )}
                          </div>
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${colorMap[renewalHosting]}`}>
                          {renewalHosting}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${hostingName === "No aplica" ? "text-gray-200" : "text-black"} ${hostingColorMap[hostingName]}`}>
                          {hostingName}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <div className="flex items-center justify-center">
                            {backupLink ? (
                              <DetailsButton content="Link de copia de seguridad" type="externalLink" action={() => window.open(backupLink.url, "_blank")} />
                            ) : (
                              <EmptyButton content="No hay link de copia de seguridad" />
                            )}
                          </div>
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${entryDateHosting ? "text-black" : "text-gray-200"}`}>
                          {entryDateHosting ? formatDate(entryDateHosting.split("T")[0]) : "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${hostingRenewalDate ? "text-black" : "text-gray-200"}`}>
                          {hostingRenewalDate ? formatDate(hostingRenewalDate.split("T")[0]) : "No aplica"}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${lineTotalHosting ? (hostingPagado ? "bg-green-50 text-green-700 font-bold" : "text-black") : "text-gray-200"}`}>
                          {formatPrice(lineTotalHosting)} {lineTotalHosting ? (hostingPagado ? "✅" : "⏳") : ""}
                        </td>
                        <td className={`px-4 py-2 whitespace-nowrap text-center border border-gray-300 ${renewalDateMap(daysToRenewHosting)}`}>
                          {daysToRenewHosting || "No aplica"}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">
                          <div className="flex items-center justify-center">
                            {commentHosting ? (
                              <Tooltip content={commentHosting}>
                                <div className="flex items-center justify-center">
                                  <FaEye className="text-black hover:cursor-pointer" />
                                </div>
                              </Tooltip>
                            ) : (
                              <FaEyeSlash className="text-gray-200" />
                            )}
                          </div>
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-center border border-gray-300">
                          {!hosting?.payment?.id ? (
                            <span className="text-gray-200">N/A</span>
                          ) : hostingPagado ? (
                            <span className="text-gray-300 text-xs">Pagado</span>
                          ) : daysToRenewHosting >= 0 ? (
                            <span className="text-gray-300 text-xs">Vigente</span>
                          ) : (() => {
                            const currentEstado = hosting?.payment?.estadoDesinstalacion || "pendiente_desinstalar";
                            const style = getEstadoDesinstalacionStyle(currentEstado);
                            return (
                              <select
                                value={currentEstado}
                                onChange={(e) => updateEstadoDesinstalacion(hosting.payment.id, e.target.value)}
                                className={`${style.bg} ${style.text} ${style.border} border rounded-md px-2 py-1 text-xs font-bold cursor-pointer outline-none`}
                              >
                                {estadoDesinstalacionOptions.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </select>
                            );
                          })()}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )
          )
        }
      </div>
      
      {/* Paginador */}
      <PaginationItem
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"renovaciones"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(e, v) => setPage(v)}
      />
    </div>
  )
}

export default RenovacionHostingyDominios